import React, { useState, Component } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ArrowRight, Mail, Calendar, Copy, Check } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: '',
    company: '',
    companySize: '',
    industry: '',
    message: ''
  });
  const [copiedEmail, setCopiedEmail] = useState<string | null>(null);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Construct email body with form data
    const emailBody = `
Full Name: ${formData.fullName}
Work Email: ${formData.workEmail}
Company: ${formData.company}
Company Size: ${formData.companySize}
Industry: ${formData.industry}

Message:
${formData.message}
    `.trim();
    // Create mailto link with pre-filled data
    const mailtoLink = `mailto:hello@meetsynthia.ai?subject=Contact Form Submission from ${encodeURIComponent(formData.fullName)}&body=${encodeURIComponent(emailBody)}`;
    // Open email client
    window.location.href = mailtoLink;
    // Optional: Reset form after a delay
    setTimeout(() => {
      setFormData({
        fullName: '',
        workEmail: '',
        company: '',
        companySize: '',
        industry: '',
        message: ''
      });
    }, 1000);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const copyEmail = (email: string) => {
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setTimeout(() => setCopiedEmail(null), 2000);
  };
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2175">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2176">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2177">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2178">
            <Link to="/" data-id="element-2179">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2180" />
            </Link>
            <Navigation data-id="element-2181" />
          </div>
        </div>
      </header>

      <main className="pt-20" data-id="element-2182">
        {/* Hero Section */}
        <section className="relative w-full pt-20 pb-16 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-2183">
          <div className="absolute top-0 right-0 pointer-events-none" style={{
          width: '100%',
          height: '800px'
        }} data-id="element-2184">
            <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[2%] w-[100%] h-auto opacity-90" data-id="element-2185" />
          </div>

          <div className="max-w-7xl mx-auto relative z-10" data-id="element-2186">
            <div className="flex flex-col space-y-8" data-id="element-2187">
              <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 w-fit" data-id="element-2188">
                <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-2189">
                  CONTACT US
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-2190">
                Let's Talk.
              </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-2191">
                We're working with select companies in regulated industries to
                transform workflows with compliant AI. Tell us about your
                challenge.
              </p>
            </div>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-16 px-6 md:px-12 lg:px-24 bg-white" data-id="element-2192">
          <div className="max-w-7xl mx-auto" data-id="element-2193">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24" data-id="element-2194">
              {/* Left Column: Form */}
              <div data-id="element-2195">
                <h2 className="text-2xl font-bold mb-8 font-['Syne']" data-id="element-2196">
                  Get in Touch
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2197">
                  <div data-id="element-2198">
                    <label htmlFor="fullName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2199">
                      Full Name
                    </label>
                    <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2200" />
                  </div>

                  <div data-id="element-2201">
                    <label htmlFor="workEmail" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2202">
                      Work Email
                    </label>
                    <input type="email" id="workEmail" name="workEmail" value={formData.workEmail} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2203" />
                  </div>

                  <div data-id="element-2204">
                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2205">
                      Company
                    </label>
                    <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2206" />
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2207">
                    <div data-id="element-2208">
                      <label htmlFor="companySize" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2209">
                        Company Size
                      </label>
                      <select id="companySize" name="companySize" value={formData.companySize} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2210">
                        <option value="" data-id="element-2211">Select range</option>
                        <option value="under-500" data-id="element-2212">Under 500</option>
                        <option value="500-3000" data-id="element-2213">500-3,000</option>
                        <option value="3000-10000" data-id="element-2214">3,000-10,000</option>
                        <option value="10000+" data-id="element-2215">10,000+</option>
                      </select>
                    </div>

                    <div data-id="element-2216">
                      <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2217">
                        Industry
                      </label>
                      <select id="industry" name="industry" value={formData.industry} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2218">
                        <option value="" data-id="element-2219">Select industry</option>
                        <option value="financial" data-id="element-2220">Financial Services</option>
                        <option value="healthcare" data-id="element-2221">
                          Healthcare/Life Sciences
                        </option>
                        <option value="legal" data-id="element-2222">Legal</option>
                        <option value="insurance" data-id="element-2223">Insurance</option>
                        <option value="pharma" data-id="element-2224">Pharma</option>
                        <option value="other" data-id="element-2225">Other</option>
                      </select>
                    </div>
                  </div>

                  <div data-id="element-2226">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2227">
                      What brings you to Synthia?
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={4} placeholder="Tell us about your workflow challenge, current AI initiatives, or what you're looking to accomplish..." className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2228" />
                  </div>

                  <button type="submit" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#0066FF] font-['Syne'] hover:bg-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2229">
                    <span data-id="element-2230">SEND MESSAGE</span>
                    <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-2231" />
                  </button>
                </form>
              </div>

              {/* Right Column: Contact Info */}
              <div className="lg:pt-0" data-id="element-2232">
                <div className="bg-[#F8F8F8] p-8 md:p-12 rounded-lg border border-gray-100 sticky top-32" data-id="element-2233">
                  <h2 className="text-2xl font-bold mb-8 font-['Syne']" data-id="element-2234">
                    Schedule a demo or reach us ASAP
                  </h2>

                  <div className="space-y-8" data-id="element-2235">
                    <div data-id="element-2236">
                      <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-2237">
                        Email us here
                      </p>
                      <div className="flex items-center gap-2" data-id="element-2238">
                        <a href="mailto:hello@meetsynthia.ai" className="text-xl font-medium hover:text-[#0066FF] transition-colors flex items-center gap-2 cursor-pointer" data-id="element-2239">
                          <Mail className="w-5 h-5" data-id="element-2240" />
                          hello@meetsynthia.ai
                        </a>
                        <button onClick={() => copyEmail('hello@meetsynthia.ai')} className="p-2 hover:bg-gray-200 rounded transition-colors" title="Copy email address" data-id="element-2241">
                          {copiedEmail === 'hello@meetsynthia.ai' ? <Check className="w-4 h-4 text-green-600" data-id="element-2242" /> : <Copy className="w-4 h-4 text-gray-500" data-id="element-2243" />}
                        </button>
                      </div>
                    </div>

                    <div data-id="element-2244">
                      <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-2245">
                        Talk to Sales
                      </p>
                      <div className="flex items-center gap-2" data-id="element-2246">
                        <a href="mailto:sales@meetsynthia.ai" className="text-xl font-medium hover:text-[#0066FF] transition-colors flex items-center gap-2 cursor-pointer" data-id="element-2247">
                          <Mail className="w-5 h-5" data-id="element-2248" />
                          sales@meetsynthia.ai
                        </a>
                        <button onClick={() => copyEmail('sales@meetsynthia.ai')} className="p-2 hover:bg-gray-200 rounded transition-colors" title="Copy email address" data-id="element-2249">
                          {copiedEmail === 'sales@meetsynthia.ai' ? <Check className="w-4 h-4 text-green-600" data-id="element-2250" /> : <Copy className="w-4 h-4 text-gray-500" data-id="element-2251" />}
                        </button>
                      </div>
                    </div>

                    <div className="pt-8 border-t border-gray-200" data-id="element-2252">
                      <a href="https://calendly.com/demo-meetsynthia" target="_blank" rel="noopener noreferrer" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black transition-all duration-200 bg-white border-2 border-black font-['Syne'] hover:bg-black hover:text-white hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2253">
                        <Calendar className="mr-2 w-5 h-5" data-id="element-2254" />
                        <span data-id="element-2255">SCHEDULE A DEMO</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-2256" />
    </div>;
}